<template>
  <ticket-flow-lib
    :application-id="deTicketApplications.FINANZAS"
    :case-type-options="itemSubTypes"
    :email="email"
    :get-case-modules-service="getCaseModulesService"
    :get-ticket-catalogues="getTicketCatalogues"
    :get-user-case-reference-number-types-service="
      getUserCaseReferenceNumberTypesService
    "
    :get-user-case-screens-service="getUserCaseScreensService"
    :save-user-case-service="saveUserCaseService"
    :validate-reference-number-service="validateReferenceNumberService"
    @close="handleClose"
  />
</template>

<script>
// libs
import TicketFlowLib from '@quisit/ticket-flow';

// services
import {
  getUserCaseReferenceNumberTypes as _getUserCaseReferenceNumberTypes,
  saveUserCase as _saveUserCase,
  validateReferenceNumber as _validateReferenceNumber,
  getUserCaseScreens as _getUserCaseScreens,
  getUserCaseModules as _getUserCaseModules,
  getTicketCatalogues as _getTicketCatalogues,
  getItemSubTypes as _getItemSubTypes,
} from '@/modules/helpdesk/api.js';

// constants
import deTicketApplications from '@/utils/constants/deTicketApplications.js';

export default {
  name: 'TicketFlow',
  components: {
    TicketFlowLib,
  },
  props: {
    email: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      deTicketApplications,
      itemSubTypes: [],
    };
  },
  async mounted() {
    await this.getItemSubTypes();
  },
  methods: {
    getUserCaseReferenceNumberTypesService(payload) {
      return _getUserCaseReferenceNumberTypes(payload);
    },
    saveUserCaseService(payload) {
      return _saveUserCase(payload);
    },
    validateReferenceNumberService(value, type) {
      return _validateReferenceNumber(value, type);
    },
    getUserCaseScreensService(moduleId) {
      return _getUserCaseScreens(moduleId);
    },
    getCaseModulesService(caseTypeId) {
      return _getUserCaseModules({
        caseTypeId,
      });
    },
    handleClose() {
      this.$root.$emit("bv::toggle::collapse', 'sidebar-create-ticket");
    },
    getTicketCatalogues(itemSubTypeId) {
      return _getTicketCatalogues(itemSubTypeId);
    },
    async getItemSubTypes() {
      const response = await _getItemSubTypes();
      if (response?.data) {
        this.itemSubTypes = response.data;
      }
    },
  },
};
</script>
